export enum Scan3dStyleRenderingMode {
  Rgb = 'Rgb',
  Classification = 'Classification',
  Clearance = 'Clearance',
  Elevation = 'Elevation',
}
